// extracted by mini-css-extract-plugin
var _1 = "t2tm";
export { _1 as "spinner" }
